// extracted by mini-css-extract-plugin
export default {"no-data-cloud-invoice":"Edit_no-data-cloud-invoice__NjPJm"};